<template>
  <div class="companyMagt">
    <div class="leftBax fl leftTabBag">
      <p class="titleP">{{ $t('company.BranchStructure') }}</p>
      <div class="searchBox">
        <el-input v-model.trim="filterText" :placeholder="$t('company.Companyname')" class="input-with-select" clearable>
          <el-button slot="append" icon="el-icon-search" />
        </el-input>
      </div>
      <el-tree ref="tree" :data="navList" node-key="idx" default-expand-all :expand-on-click-node="false" :filter-node-method="filterNode" :props="defaultProps" @node-click="handleNodeClick">
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span class="labelItem">
            <img :src="companyIcon" alt="">
            <span :title="node.label">{{ node.label }}{{ node.children }}</span>
          </span>
          <el-tooltip class="item" placement="bottom-end">
            <div class="moreIconBox">
              <div class="radiu"><div v-for="(item,index) in 3" :key="index" /></div>
              <span class="childListSize">{{ data.childListSize }}</span>
            </div>
            <div slot="content" class="tooltipBtnBox">
              <p @click="clickTooltipBtn('info',data)">{{ $t('adminView.CompanyInfo') }}</p>
              <p @click="clickTooltipBtn('add',data)">{{ $t('adminView.add') }}  {{ $t('company.childCompany') }} </p>
              <p @click="clickTooltipBtn('edit',data)">{{ $t('adminView.Edit') }}  {{ $t('adminView.CompanyInfo') }}</p>
              <p v-if="$store.state.isAdmin&&$store.state.companyId==4" @click="clickTooltipBtn('CustomConfig',data)">{{ $t('company.CustomConfig') }}</p>
              <p @click="clickTooltipBtn('delete',data)">{{ $t('adminView.delete') }}  {{ $t('company.company') }}</p>
            </div>
          </el-tooltip>
        </span>
      </el-tree>
    </div>

    <div class="rightBox bgColor6">
      <p class="titleP">{{ $t('company.companyAccount') }}</p>
      <accountTem :active-company-id="activeCompanyId" :role-options="roleOptions" :active-company-info="activeCompanyInfo" />
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="addCompanyPopShow" width="50%">
      <addEditCompanyTem :company-pop-info="companyPopInfo" :pop-statu="popStatu" :add-company-pop-show="addCompanyPopShow" @closePop="closePop" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="CustomConfigPopShow" width="70%">
      <addEditCustomConfigTem :company-pop-info="companyPopInfo" :pop-statu="popStatu" :custom-config-pop-show="CustomConfigPopShow" @closePop="closeCustomConfigPop" />
    </el-dialog>
  </div>
</template>

<script>
import { listByCompanyParentId2, deleteById, listByCompanyParentId, getRoles } from '@/api/company'
import accountTem from './accountTem'
import addEditCompanyTem from './addEditCompanyTem'
import addEditCustomConfigTem from './addEditCustomConfigTem'
export default {
  components: { addEditCompanyTem, accountTem, addEditCustomConfigTem },
  data() {
    return {
      activeReTab: 'company',
      companyId: this.$store.state.companyId,
      companyIndexShow: true,
      navList: [],
      defaultIdx: '',
      activeCompanyId: '',
      activeCompanyInfo: {},
      isCollapse: false,
      addCompanyPopShow: false,
      companyPopInfo: {
        companyParentName: null,
        companyParentId: null,
        companyName: null,
        companyAddr: null,
        companyUrl: null,
        childListSize: null,
        id: null
      },
      popStatu: 'add',
      filterText: '',
      defaultProps: {
        children: 'childList',
        label: 'companyName',
        childListSize: 'childListSize'
      },
      companyIcon: require('@/assets/icon/company.png'),
      roleOptions: [],
      CustomConfigPopShow: false
    }
  },
  computed: {
    activeIndex() {
      const current = this.$route.path
      if (current.indexOf('companyAccount') >= 0) return 2
      return 1
    },
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.initRoles()
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
    
    this.initRoles() // 获取用户角色
    setTimeout(() => {
      this.initCompanyList()// 获取左侧公司列表
    }, 100)
  },
  methods: {
    filterNode(value, data) { // 筛选过滤
      if (!value) return true
      return data.companyName.indexOf(value) !== -1
    },
    handleNodeClick(data) { // 点击节点
      this.activeCompanyId = data.id
      this.activeCompanyInfo = data// 获取公司信息
    },
    initCompanyList() { // 获取左侧公司列表
      if (!this.companyId) return
      listByCompanyParentId2({ companyParentId: this.companyId }).then(res => {
        if (res.resultCode == 1001 && res.resultModel) {
          this.navList = [res.resultModel]
          this.activeCompanyInfo = res.resultModel
          this.defaultIdx = this.activeCompanyId = res.resultModel.idx
          console.log('this.navList', this.navList)
        } else {
          this.navList = []
        }
      })
    },
    clickTooltipBtn(str, item) { // 点击左侧按钮：编辑/删除/新增/基本信息
      console.log('clickTooltipBtn:str,item', str, item)
      if (str == 'add') {
        this.openCompanyPop('add', item) // 新增分公司
      } else if (str == 'edit') {
        this.openCompanyPop('edit', item) // 编辑分公司
      } else if (str == 'delete') {
        this.deleteCompany(item) // 删除分公司
      } else if (str == 'info') {
        this.openCompanyPop('info', item) // 分公司基本信息
      } else if (str == 'CustomConfig') {
        this.CustomConfigPopShow = true
        for (var attr in this.companyPopInfo) this.companyPopInfo[attr] = item[attr]
        this.$set(this.companyPopInfo, 'time', Date.now())
        this.companyPopInfo.custDeployment = item.custDeployment
        this.popStatu = this.companyPopInfo.custDeployment ? 'edit' : 'add'
      }
    },
    initRoles() { // 获取用户角色
      this.roleOptions = []
      getRoles({ 'roleName': '' }).then(res => {
        res.resultModel.forEach(v => {
          if (v.id) {
            var value = (this.$store.state.language == 'zh' || this.$store.state.language == 'ft') ? v.roleNameZh : v.roleName
            // console.log('///////', this.$store.state.language, value)
            this.roleOptions.push({
              value: value,
              key: v.id
            })
          }
        })
      })
    },
    openCompanyPop(val, item) { // 新增/编辑分公司弹窗--打开
      this.addCompanyPopShow = true
      this.popStatu = val
      if (val == 'add') { // 新增.新增是相当于新增下级分公司，所以上级公司是当前公司
        for (var attr in this.companyPopInfo) this.companyPopInfo[attr] = null
        this.companyPopInfo.companyParentName = item.companyName
        this.companyPopInfo.companyParentId = item.id
      } else { // 编辑。编辑是编辑当前公司，所以上级公司是当前公司的上级公司
        for (var attr in this.companyPopInfo) this.companyPopInfo[attr] = item[attr]
      }
    },
    closePop(val) { // /新增/编辑分公司弹窗--关闭
      this.addCompanyPopShow = false
      if (val == 'needInt') this.initCompanyList()// 初始化
    },
    closeCustomConfigPop(val) { // 新增/编辑客户化配置弹窗--关闭
      this.CustomConfigPopShow = false
      if (val == 'needInt') this.initCompanyList()// 初始化
    },
    deleteCompany(item) { // 删除分公司
      this.$confirm(this.$t('company.Deletechildcompanies'), '', {// 是否删除该公司及其下所有子公司？
        confirmButtonText: this.$t('button.Confirm'), // '确定'
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteById({ 'id': item.id }).then(res => {
          if (res.resultCode == '1001') {
            this.$message({
              message: this.$t('lease.Succeed'),
              type: 'success'
            })
            this.initCompanyList()// 获取左侧公司列表
            console.log('this.$store', this.$store)
          } else {
            this.$message({
              type: 'error',
              message: res.resultMessage
            })
          }
        })
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.companyMagt {
  height: 100%;
  // .el-tree {
  //   background: #f0f2f5;
  // }
  .leftBax {
    height: 100%;
    border-radius: 16px;
    padding: 30px;
    width: 30%;
    overflow: hidden;
    background: #fff;
  }
  .rightBox {
    height: 100%;
    width: calc(70% - 20px);
    margin-left: calc(30% + 20px);
    border-radius: 16px;
    padding: 30px;
    background: #fff;
  }

  .boxTabWarp {
    position: relative;
    height: 100%;
    border-radius: 16px;
    overflow-y: scroll;
  }
  .el-tree{
    margin-top: 20px;
    max-height: calc(100% - 110px);
    overflow: auto;
    padding-right: 10px;
    .labelItem img{
      width: 22px;
      vertical-align: sub;
    }
    .custom-tree-node{
      overflow: hidden;
      word-break: normal;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 70px 0 0;
    }
    .el-tree-node__content{
      position: relative;
      height: 35px;
      line-height: 35px;
    }
  }
  .titleP{
    margin-bottom: 20px;
    font-size: 14px;
  }
  .moreIconBox{
    position: absolute;
    right: 0;
    height: 60%;
    top: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    padding-left:30px;
    .radiu{
      display: flex;
      margin-right: 10px;
      &>div{
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background:#606266;
        margin:0 1px;
      }
    }
  }
}
</style>
